import axiosInstance from "../../../api/axiosConfig";

export const getSampleProducts = (params: any) => {
  return axiosInstance.get("/admin/sample-products", {
    params: params,
  });
};

export const downloadSample = () => {
  return axiosInstance.post("/admin/stock-products/download-sample");
};

export const deleteSampleProduct = (id: string) => {
  return axiosInstance.delete(`/admin/sample-products/${id}`);
};

export const importSampleProducts = (data: any) => {
  return axiosInstance.post("/admin/sample-products/import", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteImages = () => {
  return axiosInstance.post("/admin/sample-products/delete-images");
};

export const checkImageExist = () => {
  return axiosInstance.post("/admin/sample-products/check-image-exists");
};
